import React, { Component, Fragment } from 'react'
import ReactDOM from 'react-dom'
import {Form, InputGroup, Button} from 'react-bootstrap';
// import Dropzone from 'react-dropzone-uploader';

const ImportFromFile = (props) => {
    let fileReader;

    const handleFileRead = (e) => {
        const content = fileReader.result;
        console.log(content);
        const readerArr = content.replace(/\n/g, ",").split(",");

        const labels = readerArr.filter((item, index) => index % 3 === 0 );
        const values = readerArr.filter((item, index) => index % 3 === 1 );
        const colors = readerArr.filter((item, index) => index % 3 === 2 );
        console.log(labels);
        console.log(values);
        console.log(colors);
        console.log(readerArr);
        props.csvData(labels,values,colors)
    }

    const handleFileChosen = (file) => {
        fileReader = new FileReader();
        fileReader.onloadend = handleFileRead;
        fileReader.readAsText(file);
    }

    return(
            <div style={{paddingBottom: "16px", borderBottom: "1px solid #ced4da"}}>
                {/* <Form.Label>Add Data from CSV</Form.Label> */}
                
                {/* <Form.Control style={{margin: "0 auto !important", width: "50% !important" }} type="file"
                    id='file'
                    className='input-file'
                    accept='.csv'
                    onChange={e => handleFileChosen(e.target.files[0])}
                /> */}
                <label class="btn btn-primary" for="my-file-selector">
                <input id="my-file-selector" type="file" style={{display:"none"}} accept='.csv'
                    onChange={e => handleFileChosen(e.target.files[0])}/>
                Choose CSV File
                </label>
                <span class='label label-info' id="upload-file-info"></span>
            </div>
    )
}

export default ImportFromFile;

// const MyUploader = () => {
//     // specify upload params and url for your files
//     const getUploadParams = ({ meta }) => { return { url: 'https://httpbin.org/post' } }
    
//     // called every time a file's `status` changes
//     const handleChangeStatus = ({ meta, file }, status) => { console.log(status, meta, file) }
    
//     // receives array of files that are done uploading when submit button is clicked
//     const handleSubmit = (files, allFiles) => {
//       console.log(files.map(f => f.meta))
//       allFiles.forEach(f => f.remove())
//     }
  
//     return (
//       <Dropzone
//         getUploadParams={getUploadParams}
//         onChangeStatus={handleChangeStatus}
//         onSubmit={handleSubmit}
//         accept=".csv"
//       />
//     )
//   }

// export default MyUploader;